import fertigationDataConfig from '@/api/config/fertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { CreateFertigation } from '@/types/fertigation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreateFertigation): Promise<void> {
  await fertigationDataConfig.create(payload)
}

function useAddFertigation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateFertigation) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.fertigation])
      toast.success(t('addFertigationSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else if (error?.statusCode === 404) {
        toast.error(error?.message)
      } else toast.error(t('addFertigationError'))
    },
  })
}

export default useAddFertigation
